module.exports = __webpack_public_path__ + "img/35.bee99e90.png";